export const state = () => ({
  order: {}
});

export const mutations = {
  set (state, privacyPolicy) {
    state.privacyPolicy = privacyPolicy;
  }
};

export const getters = {
  get (state) {
    return state.privacyPolicy;
  }
};
